import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  reset() {
    // Only clear text inputs, not hidden fields (context_id, context_type)
    // which may have been updated dynamically via Turbo Stream broadcasts
    this.element.querySelectorAll('input[type="text"], textarea').forEach(el => {
      el.value = ''
    })
  }
}
